import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { Select, MenuItem, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getExamReportsData } from '../../features/dashboard/dashboardSlice';
import { getExaminationsList } from '../../features/examinations/examinationSlice';
import { getLabelsByInstituteType } from '../../utils/constants';
import { MenuProps } from '../../utils/constants';
const ExamResultReport = ({ classesData }) => {
  const dispatch = useDispatch();
  const [examReportsData, setExamReportsData] = useState([]);
  const [Exams, setExams] = useState([]);
  const [classDetails, setClassDetails] = useState([]);
  const [currentClasses, setCurrentClasses] = useState([]);
  const [currentSections, setCurrentSections] = useState([]);
  const [searchValues, setSearchValues] = useState({
    departmentName: '',
    className: '',
    sectionName: '',
    examType: '',
  });
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const { Department, Class, Section } =
    getLabelsByInstituteType(instituteType);
  async function fetchExamReportsDate(searchData) {
    try {
      const data = await dispatch(getExamReportsData(searchData)).unwrap();
      data ? setExamReportsData(data) : '';
    } catch (error) {
      console.log(error);
    }
  }
  const getClasses = async () => {
    try {
      const list = await dispatch(getExaminationsList()).unwrap();
      setExams(list);
    } catch (error) {
      console.log(error);
    }
  };
  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
  }) => {
    if (value === 0) return null;

    const radius = innerRadius + (outerRadius - innerRadius) / 2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill='white'
        textAnchor='middle'
        dominantBaseline='central'
        className='text-sm font-semibold'
      >
        {value}%
      </text>
    );
  };

  useEffect(() => {
    setClassDetails(classesData);
    getClasses();
  }, [classesData]);
  const COLORS = ['#3EC043', '#E51212', '#0047FF']; //green,red,blue

  return (
    <div className='bg-white rounded-lg shadow-sm size-full h-[300px]'>
      {/* Header */}
      <div className='flex flex-wrap items-start justify-between gap-1 p-2'>
        <div className='w-fit'>
          <Typography variant='h6'>Exam Results Report</Typography>
        </div>

        <div className='flex flex-wrap gap-2'>
          {/* Department */}
          <Select
            MenuProps={MenuProps}
            displayEmpty
            value={searchValues.departmentName}
            onChange={(e) => {
              const dept = classDetails?.find(
                (obj) => obj.department === e.target.value,
              );
              setCurrentClasses(dept?.classes);
              setSearchValues({
                ...searchValues,
                departmentName: e.target.value,
                className: '',
                sectionName: '',
                examType: '',
              });
            }}
            labelId='class-label'
            sx={{
              maxWidth: 'fit',
              height: '24px',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // keep same on hover
              },
              '&.MuiSelect-select:focus': {
                backgroundColor: 'transparent', // remove blue background on focus
              },
            }}
          >
            <MenuItem value=''>{Department}</MenuItem>

            {classDetails?.length > 0 &&
              classDetails?.map((obj) => (
                <MenuItem key={obj.id} value={obj.department}>
                  {obj.department}
                </MenuItem>
              ))}
          </Select>
          {/* Class */}
          <Select
            MenuProps={MenuProps}
            displayEmpty
            value={searchValues.className}
            onChange={(e) => {
              const Class = currentClasses?.find(
                (obj) => obj.className === e.target.value,
              );
              setCurrentSections(Class?.sections);
              setSearchValues({
                ...searchValues,
                className: e.target.value,
                sectionName: '',
              });
              if (
                searchValues.departmentName &&
                searchValues.examType &&
                e.target.value
              ) {
                fetchExamReportsDate({
                  ...searchValues,
                  className: e.target.value,
                  sectionName: '',
                });
              }
            }}
            labelId='class-label'
            sx={{
              maxWidth: 'fit',
              height: '24px',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // keep same on hover
              },
              '&.MuiSelect-select:focus': {
                backgroundColor: 'transparent', // remove blue background on focus
              },
            }}
          >
            <MenuItem value=''>{Class}</MenuItem>

            {currentClasses?.length > 0 &&
              currentClasses?.map((obj) => (
                <MenuItem key={obj.id} value={obj.className}>
                  {obj.className}
                </MenuItem>
              ))}
          </Select>
          {/* Section */}
          {instituteType.toLowerCase() === 'college' && (
            <Select
              MenuProps={MenuProps}
              displayEmpty
              value={searchValues.sectionName}
              onChange={(e) => {
                setSearchValues({
                  ...searchValues,
                  sectionName: e.target.value,
                });
                if (
                  searchValues.departmentName &&
                  searchValues.className &&
                  searchValues.examType &&
                  e.target.value
                ) {
                  fetchExamReportsDate({
                    ...searchValues,
                    sectionName: e.target.value,
                  });
                }
              }}
              labelId='class-label'
              sx={{
                maxWidth: 'fit',
                height: '24px',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // normal border color
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // normal border color
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc', // keep same on hover
                },
                '&.MuiSelect-select:focus': {
                  backgroundColor: 'transparent', // remove blue background on focus
                },
              }}
            >
              <MenuItem value=''>{Section}</MenuItem>

              {currentSections?.length > 0 &&
                currentSections?.map((obj) => (
                  <MenuItem key={obj.id} value={obj.section}>
                    {obj.section}
                  </MenuItem>
                ))}
            </Select>
          )}
          {/* Exam Type */}
          <Select
            MenuProps={MenuProps}
            displayEmpty
            value={searchValues.examType}
            onChange={(e) => {
              // const Class = currentClasses?.find(
              //   (obj) => obj.className === e.target.value,
              // );
              // setCurrentSections(Class?.sections);
              setSearchValues({
                ...searchValues,
                examType: e.target.value,
              });

              if (
                searchValues.departmentName &&
                searchValues.className &&
                (instituteType.toLowerCase() === 'college'
                  ? searchValues.sectionName
                  : true) &&
                e.target.value
              ) {
                fetchExamReportsDate({
                  ...searchValues,
                  examType: e.target.value,
                });
              }
            }}
            labelId='class-label'
            sx={{
              maxWidth: 'fit', // custom width
              height: '24px',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // normal border color
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ccc', // keep same on hover
              },
              '&.MuiSelect-select:focus': {
                backgroundColor: 'transparent', // remove blue background on focus
              },
            }}
          >
            <MenuItem value=''>ExamType</MenuItem>

            {Exams?.length > 0 &&
              Exams?.map((obj) => (
                <MenuItem key={obj.id} value={obj.examType}>
                  {obj.examType}
                </MenuItem>
              ))}
          </Select>
        </div>
      </div>

      {/* Pie Chart */}

      {examReportsData?.every((obj) => obj.value == 0) ? (
        <div className='flex items-center justify-center w-full mt-20'>
          <Typography variant='body1'>No Percentage Results</Typography>
        </div>
      ) : searchValues.departmentName &&
        searchValues.className &&
        searchValues.examType ? (
        <div className='w-full overflow-auto '>
          {' '}
          {/* Chart + Legend */}
          <div className=' min-w-[370px] p-2 flex items-center '>
            <ResponsiveContainer width='100%' height={230}>
              <PieChart>
                <Pie
                  data={examReportsData}
                  dataKey='value'
                  nameKey='name'
                  cx='50%'
                  cy='50%'
                  outerRadius={100}
                  labelLine={false}
                  label={renderCustomizedLabel}
                >
                  {examReportsData?.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>

                <Tooltip
                  content={({ active, payload }) => {
                    if (active && payload && payload.length) {
                      return (
                        <div className='p-3 text-sm bg-white border rounded-md shadow-lg'>
                          <div className='text-blue-600'>
                            {payload?.[0]?.payload?.name
                              ?.charAt(0)
                              ?.toUpperCase() +
                              payload?.[0]?.payload?.name?.slice(1)}
                            : {payload?.[0]?.payload?.value + '%'}
                          </div>
                        </div>
                      );
                    }

                    return null;
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className='flex flex-col justify-center w-40 '>
              <div className='flex  gap-2 '>
                {' '}
                <div className='w-5 h-3 mt-2 rounded-full bg-[#3EC043]'></div>
                <div>
                  <div>Pass &nbsp;{examReportsData?.[0]?.value}%</div>
                </div>
              </div>
              <div className='flex gap-2 '>
                {' '}
                <div className='w-5 h-3 mt-2 rounded-full bg-[#E51212]'></div>
                <div>
                  <div>Fail &nbsp;{examReportsData?.[1]?.value}%</div>
                </div>
              </div>
              <div className='flex gap-2 '>
                {' '}
                <div className='w-5 h-3 mt-2 rounded-full bg-[#0047FF]'></div>
                <div>
                  <div>Others {examReportsData?.[2]?.value}%</div>
                  <small>(Marks Not Entered)</small>
                </div>
              </div>
            </div>{' '}
          </div>
        </div>
      ) : (
        <div className='w-full mt-16 mb-20 text-center'>
          <Typography variant='body1'>
            {' '}
            Please Select the class details to get Results
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ExamResultReport;
